import { render, staticRenderFns } from "./DownloadGenerico.vue?vue&type=template&id=fee27e3c&scoped=true"
import script from "./DownloadGenerico.vue?vue&type=script&lang=js"
export * from "./DownloadGenerico.vue?vue&type=script&lang=js"
import style0 from "./DownloadGenerico.vue?vue&type=style&index=0&id=fee27e3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fee27e3c",
  null
  
)

export default component.exports